/**
スクロールでエリアに入るとクラスを付与

target : 検知対象となる class / id
config : {
    class:{
        // 画面内に入ったら付与
        'in' : 'inView_in',
        // 画面の外に出たら付与
        'out' : 'inView_out'
    }
    // 画面に入った判定の距離。0にすると画面端で判定
    // 必ずin_rangeより小さい値にする
    in_range : 50,
    // 画面から出た判定の距離
    out_range: 0,
    //表示エリアの中だけピンをたてる。上にスクロールするとまた表示
    is_inView_only: false
}
*/


export default class CaracolScrollInView {

    /**
     * コンストラクタ
     * @param {string} target jQuery selector string
     * @param {object} config
     */
    constructor(target, config) {

        const defaults = {
            class: {
                in: 'inView_in',
                out: 'inView_out'
            },
            in_range: 50,
            out_range: 40,  // 画面外判定。
            margin_bottom: 50,  // 最下部の許容値
            is_inView_only: false

        };

        this.opt = Object.assign(defaults, config);
        this.target = target;
        this.$target = $(target);
        this.$window = $(window);
        this.is_started = false;
        this.is_ended = false;  // 全部表示した
        this.win_height = null;
        this.doc_height = null;
        this.interval_id = null;

        this.DATA_TOP = 'ccl-inView-top';
        this.DATA_BOTTOM = 'ccl-inView-bottom';
    }

    /**
     * スクロール検知処理を開始
     */
    start() {

        // すでに開始していたら無視
        if (this.is_started) return;

        // 各アイテムの高さをチェック
        this._check_element();
        this.interval_id = setInterval(() => { this._check_element(); }, 2000);

        // リサイズイベントでドキュメント高さチェック
        this._resize();
        const ev_resize = $.throttle(100, () => { this._resize(); });
        this.$window.on('resize', ev_resize);

        // スクロールイベント
        this._scroll();
        const ev_scroll = $.throttle(100, () => { this._scroll(); });
        this.$window.on('scroll', () => { ev_scroll(); });

        this.is_started = true;
    }

    /**
    * 検知処理を終了
    */
    // stop() {
    //     clearInterval(this.interval_id);
    //     this.$window.off('resize', () => { this._resize(); });
    //     this.$window.off('scroll', () => { this._scroll(); });
    // }


    /**
     * プライベートメソッド
     */

    /**
     * 対象エレメントの座標と高さをチェック
     */
    _check_element() {
        const DATA_TOP = this.DATA_TOP;
        const DATA_BOTTOM = this.DATA_BOTTOM;

        // 各ターゲットエレメントのY座標をチェック
        // エレメントに位置を記録
        this.$target.each(function () {
            const $elm = $(this);
            const top = $elm.offset().top;
            const bottom = top + $elm.height();
            $elm.data(DATA_TOP, top);
            $elm.data(DATA_BOTTOM, bottom);
        });
    }

    /**
     * スクロール処理
     */
    _scroll() {
        const $target = this.$target;
        const opt = this.opt;

        // スクロール上位置と下位置
        const scroll_top = this.$window.scrollTop();
        const scroll_bottom = scroll_top + this.win_height;

        // 対象エレメントを順にチェック
        $target.each((index, elm) => {

            // エレメントの上辺・下辺を取得
            const $elm = $(elm);
            const top = $elm.data(this.DATA_TOP);
            const bottom = $elm.data(this.DATA_BOTTOM);

            // エリア内限定の設定ではなく、
            // すでに完了クラスが付与されていたら無視
            if (!opt.is_inView_only && $elm.hasClass(opt.class.in)) return true;

            if (!opt.is_inView_only && scroll_bottom - opt.in_range > top) {
                // 画面内判定：表示エリアより上は全部ピン立てる
                $elm.addClass(opt.class.in);
            } else {
                // 表示エリア内だけ
                if (this._is_inView(top, bottom, scroll_top, scroll_bottom)) {

                    // 表示エリアに入ったらクラスを付与
                    $elm.removeClass(opt.class.out);
                    $elm.addClass(opt.class.in);
                } else if ($elm.hasClass(opt.class.in) &&
                    this._is_outView(top, bottom, scroll_top, scroll_bottom)) {

                    // エリアから出たのに、入っている状態のものはクラスを剥奪
                    $elm.removeClass(opt.class.out);
                    $elm.addClass(opt.class.out);
                }
            }
            return true;
        });

        // エリア内限定でないなら、一番下までスクロールしたら停止
        // if (!opt.is_inView_only) {
        //     if (scroll_bottom >= this.doc_height - opt.margin_bottom) {
        //         this.stop();
        //     }
        // }
    }

    /**
     * エリア内にエレメントが見えているか
     * element top / element bttom / scroll top / scroll bottom
     */
    _is_inView(et, eb, st, sb) {
        const ir = this.opt.in_range;
        // 上辺が画面内 || 下辺が画面内
        if ((st + ir < et && et < sb - ir) ||
            (st + ir < eb && eb < sb - ir)) return true;
        return false;
    }

    /**
    * エリア外に移動したか
    * element top / element bttom / scroll top / scroll bottom
    */
    _is_outView(et, eb, st, sb) {
        const or = this.opt.out_range;
        // 下辺が画面外 || 上辺が画面外
        if (eb < st + or || sb - or < et) return true;
        return false;
    }

    /**
    * ウィンドウをリサイズしたら高さなどをチェック
    */
    _resize() {
        this.win_height = this.$window.height();
        this.doc_height = $(document).height();
    }

}






// WEBPACK FOOTER //
// /Users/dada/www/_caracol_works/javascript/for_webpack/caracol/caracol_es2015.1.0/effect/scroll_in_view.js